import { LegalPage, LegalSection } from "./LegalPage";

export const PrivacyPolicy = () => (
  <LegalPage title="Privacy Policy" testid="privacy-policy-page">
    <LegalSection title="1. Titolare del trattamento">
      <p>
        Il titolare del trattamento dei dati personali è{" "}
        <strong className="text-zinc-200">FIX ROMA H24</strong> — Roma e
        provincia.
      </p>
      <p>
        Sede legale: Via di Torre Morena 92, 00118 Roma (RM) — P.IVA
        13434831007.
      </p>
      <p>
        Contatti del titolare: telefono{" "}
        <a href="tel:+390685902421" className="text-amber-400 hover:text-amber-300">
          06 8590 2421
        </a>
        , email{" "}
        <a href="mailto:fixromah24@libero.it" className="text-amber-400 hover:text-amber-300">
          fixromah24@libero.it
        </a>
        .
      </p>
    </LegalSection>

    <LegalSection title="2. Dati personali raccolti">
      <p>
        <strong className="text-zinc-200">Dati forniti volontariamente.</strong>{" "}
        Quando ci contatti tramite il modulo del sito, per telefono o via
        email, raccogliamo i dati che ci fornisci: nome, recapito telefonico,
        zona/comune, tipologia di problema e descrizione del guasto.
      </p>
      <p>
        <strong className="text-zinc-200">Dati di navigazione.</strong> I
        sistemi informatici del sito acquisiscono, nel corso del loro normale
        funzionamento, alcuni dati tecnici (ad esempio indirizzo IP, tipo di
        browser, pagine visitate) necessari al funzionamento del sito e a
        fini statistici aggregati.
      </p>
    </LegalSection>

    <LegalSection title="3. Finalità e base giuridica del trattamento">
      <p>I dati personali sono trattati per:</p>
      <ul className="list-disc space-y-2 pl-5">
        <li>
          gestire le richieste di pronto intervento e ricontattarti (esecuzione
          di misure precontrattuali — art. 6, par. 1, lett. b GDPR);
        </li>
        <li>
          adempiere ad eventuali obblighi di legge (art. 6, par. 1, lett. c
          GDPR);
        </li>
        <li>
          elaborare statistiche aggregate e anonime sull'utilizzo del sito per
          migliorarne il funzionamento (legittimo interesse — art. 6, par. 1,
          lett. f GDPR).
        </li>
      </ul>
    </LegalSection>

    <LegalSection title="4. Modalità del trattamento e conservazione">
      <p>
        I dati sono trattati con strumenti informatici e con misure di
        sicurezza adeguate a proteggerne la riservatezza. I dati delle
        richieste di contatto sono conservati per il tempo necessario a
        gestire l'intervento richiesto e secondo i termini previsti dalla
        legge.
      </p>
    </LegalSection>

    <LegalSection title="5. Comunicazione a terzi">
      <p>
        I dati non sono venduti né ceduti a terzi per finalità di marketing.
        Se necessario per gestire l'intervento richiesto, alcuni dati (ad
        esempio recapito e zona) possono essere comunicati a un professionista
        partner incaricato dell'intervento, nel rispetto della normativa
        applicabile.
      </p>
    </LegalSection>

    <LegalSection title="6. Diritti dell'interessato">
      <p>
        Puoi esercitare in qualsiasi momento i diritti previsti dagli artt.
        15-22 del GDPR: accesso, rettifica, cancellazione, limitazione del
        trattamento, portabilità e opposizione. Per esercitarli scrivi a{" "}
        <a href="mailto:fixromah24@libero.it" className="text-amber-400 hover:text-amber-300">
          fixromah24@libero.it
        </a>
        .
      </p>
      <p>
        Hai inoltre il diritto di proporre reclamo al Garante per la
        protezione dei dati personali (
        <a
          href="https://www.garanteprivacy.it"
          target="_blank"
          rel="noopener noreferrer"
          className="text-amber-400 hover:text-amber-300"
        >
          www.garanteprivacy.it
        </a>
        ).
      </p>
    </LegalSection>

    <LegalSection title="7. Cookie">
      <p>
        Per informazioni sull'uso dei cookie consulta la{" "}
        <a href="/cookie-policy" className="text-amber-400 hover:text-amber-300">
          Cookie Policy
        </a>
        .
      </p>
    </LegalSection>
  </LegalPage>
);
